/**
 * SHER-444 — in-memory patient list helpers for Redux updates without
 * re-reading the full IndexedDB census.
 */

export function upsertPatientInList(list, patient) {
    if (!patient) return list || [];
    if (!list || list.length === 0) return [patient];
    const index = list.findIndex((p) => p.uuid === patient.uuid);
    if (index === -1) return [...list, patient];
    const next = [...list];
    next[index] = patient;
    return next;
}

export function removePatientFromList(list, uuid) {
    if (!list || list.length === 0) return [];
    return list.filter((p) => p.uuid !== uuid);
}

export function applyPatientSyncPatches(list, patches) {
    let next = list ? [...list] : [];
    for (const patch of patches) {
        if (!patch) continue;
        if (patch.op === 'upsert') {
            next = upsertPatientInList(next, patch.patient);
        } else if (patch.op === 'delete') {
            next = removePatientFromList(next, patch.uuid);
        }
    }
    return next;
}
